import { IGiftItemResponse } from '../../types/itemTypes'
import { ICategoryResponse } from '../../types/organisation'
import { ItemOrder } from './select/OrderSelect'

const getValue = (value: string | undefined): number => {
  if (value) {
    if (value.includes(',')) {
      const array = value.split(',')
      return parseFloat(array[0])
    }
    return parseFloat(value)
  }
  return 0
}

export const filterGiftItems = (
  items: IGiftItemResponse[],
  categoryId: number | undefined,
  subCategories: ICategoryResponse[] | undefined,
  order: ItemOrder | undefined,
): IGiftItemResponse[] => {
  const sortByOrder = (a: IGiftItemResponse, b: IGiftItemResponse): number => {
    if (a.order && b.order) {
      return a.order - b.order
    }
    return 0
  }

  const masterArray = []

  if (categoryId) {
    const categoryItems = items.filter((item) => {
      if (item.categoryIds) {
        return item.categoryIds.includes(categoryId)
      }
      return false
    })
    categoryItems.sort(sortByOrder)
    masterArray.push(...categoryItems)
  }

  if (subCategories) {
    const subCategoryItemArray: IGiftItemResponse[] = []

    subCategories.forEach((subCategory) => {
      if (subCategory.parent === categoryId) {
        const subCategoryItems = items.filter((item) => {
          if (item.categoryIds) {
            return item.categoryIds.includes(subCategory.id)
          }
          return false
        })
        subCategoryItems.sort(sortByOrder)
        subCategoryItemArray.push(...subCategoryItems)
      }
    })
    masterArray.push(...subCategoryItemArray)
  }

  if (!categoryId) {
    masterArray.push(...items)
    masterArray.sort(sortByOrder)
  }

  if (order) {
    masterArray.sort((a, b) => {
      const aValue = getValue(a.value)
      const bValue = getValue(b.value)

      if (order === ItemOrder.Low) {
        return aValue - bValue
      }
      return bValue - aValue
    })
  }

  // filter out duplicates, as sometimes we "Show all" which can include multiple categories and
  // items can be in more than one category
  const uniqueArray: IGiftItemResponse[] = []
  masterArray.forEach((item) => {
    const alreadyAdded = uniqueArray.find(
      (uniqueItem) => uniqueItem.id === item.id,
    )
    if (!alreadyAdded) uniqueArray.push(item)
  })

  return uniqueArray
}
